import type { ComponentProps, FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'outline' | 'light' | 'outline-light'

interface ButtonLinkProps extends ComponentProps<typeof Link> {
    variant?: ButtonVariant
}

const BASE = 'inline-flex h-12 items-center justify-center gap-3 px-8 text-center text-[0.6875rem] font-medium uppercase tracking-[0.22em] transition-colors duration-300 disabled:pointer-events-none disabled:opacity-50'

const VARIANTS: Record<ButtonVariant, string> = {
    primary: 'bg-foreground text-background hover:bg-foreground/85',
    outline: 'border border-foreground text-foreground hover:bg-foreground hover:text-background',
    light: 'bg-background text-foreground hover:bg-background/85',
    'outline-light': 'border border-background/70 text-background hover:bg-background hover:text-foreground'
}

export const buttonClasses = (variant: ButtonVariant = 'primary', className?: string): string =>
    cn(BASE, VARIANTS[variant], className)

export const ButtonLink: FC<ButtonLinkProps> = ({ variant = 'primary', className, children, ...props }): ReactNode => {
    return (
        <Link className={buttonClasses(variant, className)} {...props}>
            {children}
        </Link>
    )
}
